import styled from 'styled-components';

const Button = styled.div`
  grid-area: next;

  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  text-decoration: underline;
  text-decoration-style: solid;

  line-height: 1.4;
  color: #004bc4;
  transition: all 0.3s ease-in;

  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

export default Button;
